import { Link } from "react-router-dom";
import { CalendarClock, Dog, Stethoscope, Truck, Wheat } from "lucide-react";

const TOOLS = [
  { to: "/kilavuz/yem-rasyon", icon: Wheat, title: "Rasyon Hesapla",
    text: "Büyükbaş ve küçükbaş için yem karması ve maliyet — çiftlik panelinden." },
  { to: "/kopek-mama-hesapla", icon: Dog, title: "Pet Mama Hesapla",
    text: "Köpek ve kediniz için günlük kalori aralığı ve gram hesabı." },
  { to: "/asi-takvimi", icon: CalendarClock, title: "Aşı Takvimi Hesapla",
    text: "Yaşa ve yaşam tarzına göre önerilen koruyucu sağlık takvimi." },
  { to: "/veterinerler", icon: Stethoscope, title: "Veteriner Bul",
    text: "Bakanlık ruhsatlı hastane, poliklinik ve muayenehane kayıtları." },
  { to: "/nakliyeci-bul", icon: Truck, title: "Nakliyeci Bul",
    text: "Hayvan nakliyecisi arayın, güzergâh ve tür bazında teklif isteyin." },
];

export const FreeTools = () => (
  <section className="border-y border-border bg-card" data-testid="home-free-tools">
    <div className="mx-auto max-w-7xl px-4 py-14 lg:px-8">
      <h2 className="font-display text-2xl font-extrabold text-primary sm:text-3xl">
        Ücretsiz Araçlar
      </h2>
      <p className="mt-2 text-base text-muted-foreground">
        Üyelik gerekmez — hesaplayın, arayın, hemen kullanın.
      </p>
      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {TOOLS.map(({ to, icon: Icon, title, text }) => (
          <Link key={to} to={to} data-testid={`home-tool-${to.replace("/", "")}`}
            className="group flex flex-col gap-4 rounded-lg border border-border bg-background p-6 transition-colors duration-200 hover:border-secondary">
            <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary text-primary-foreground">
              <Icon className="h-6 w-6" />
            </span>
            <span>
              <span className="block font-display text-lg font-extrabold text-primary">{title}</span>
              <span className="mt-1 block text-sm text-muted-foreground">{text}</span>
            </span>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default FreeTools;
